"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenList = void 0;
var react_1 = __importStar(require("react"));
var withPolyfill_1 = __importDefault(require("react-resize-detector/build/withPolyfill"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var ScrollableContainer_1 = require("../ScrollableContainer/ScrollableContainer");
var VirtualList_1 = require("../VirtualList/VirtualList");
var TokenLoadingSpinner_1 = require("Project/Actions/Tokens/Common/TokenLoadingSpinner");
var TokenList = (function (_super) {
    __extends(TokenList, _super);
    function TokenList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.scrollPosition = 0;
        _this._startElementHeight = 0;
        _this.startElementRef = (0, react_1.createRef)();
        _this.renderListItem = function (index) {
            var _a = _this.props, tokens = _a.tokens, renderListItem = _a.renderListItem;
            if (index < tokens.length) {
                return react_1.default.createElement("div", { key: "token-list-item-".concat(index) }, renderListItem(tokens[index]));
            }
            else {
                throw new Error("Attempting to render a token outside the range of the token list");
            }
        };
        return _this;
    }
    TokenList.prototype.componentDidMount = function () {
        this.measureStartElement();
    };
    Object.defineProperty(TokenList.prototype, "startElementHeight", {
        get: function () {
            if (!!this.props.startElement) {
                return this._startElementHeight;
            }
            else {
                return 0;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TokenList.prototype, "visibleListHeight", {
        get: function () {
            return this.props.listHeight - Math.max(this.startElementHeight - this.scrollPosition, 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TokenList.prototype, "listRelativeScrollPosition", {
        get: function () {
            return Math.max(this.scrollPosition - this.startElementHeight, 0);
        },
        enumerable: false,
        configurable: true
    });
    TokenList.prototype.onScroll = function (scrollPosition) {
        this.scrollPosition = scrollPosition;
    };
    TokenList.prototype.measureStartElement = function () {
        var startElement = this.props.startElement;
        var getHeight = function (ref) { var _a; return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height; };
        if (startElement) {
            this._startElementHeight = getHeight(this.startElementRef) || 0;
        }
    };
    TokenList.prototype.render = function () {
        var listHeight = this.props.listHeight;
        return (react_1.default.createElement(ScrollableContainer_1.ScrollableContainer, { className: "token-list", style: { height: "".concat(listHeight, "px") }, onScroll: this.onScroll },
            this.renderStartElement(),
            this.renderList()));
    };
    TokenList.prototype.renderStartElement = function () {
        var startElement = this.props.startElement;
        if (!!startElement) {
            return (react_1.default.createElement("div", { className: "token-list__start-element", ref: this.startElementRef },
                react_1.default.createElement(withPolyfill_1.default, { handleHeight: true, onResize: this.measureStartElement }, startElement)));
        }
        else {
            return null;
        }
    };
    TokenList.prototype.renderList = function () {
        var _a = this.props, className = _a.className, isLoading = _a.isLoading, listItemHeight = _a.listItemHeight, tokens = _a.tokens, renderEmptyState = _a.renderEmptyState;
        if (isLoading) {
            return react_1.default.createElement(TokenLoadingSpinner_1.TokenLoadingSpinner, null);
        }
        else if (tokens.length === 0) {
            return renderEmptyState();
        }
        else {
            return (react_1.default.createElement("div", { className: className },
                react_1.default.createElement(VirtualList_1.List, { containerSize: this.visibleListHeight, scrollPosition: this.listRelativeScrollPosition, itemCount: tokens.length, itemSize: listItemHeight, renderItem: this.renderListItem })));
        }
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], TokenList.prototype, "scrollPosition", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], TokenList.prototype, "_startElementHeight", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], TokenList.prototype, "startElementHeight", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], TokenList.prototype, "visibleListHeight", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], TokenList.prototype, "listRelativeScrollPosition", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], TokenList.prototype, "onScroll", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TokenList.prototype, "measureStartElement", null);
    TokenList = __decorate([
        mobx_react_1.observer
    ], TokenList);
    return TokenList;
}(react_1.default.Component));
exports.TokenList = TokenList;
